export default {
  setTooltips (state, tooltips) {
    state.tooltips = tooltips
  }
}
